<template>
  <app-modal
    ref="modal"
    modal-header-title="Thông tin đơn hàng"
    size="xl"

  >
    <template v-slot:header>
      <div class="modal-header clearfix text-left">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="handlerClose()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <span class="title">{{ $t('student_order.order_modal.modal_title') }}</span>
      </div>
    </template>
    <template v-slot:container>
      <div class="bg-white app-table-container">
        <!-- title -->
        <div class="row">
          <div class="col-sm-12 text-center font-weight-bold mb-2" style="font-size: 20px; color: #4472c4;">
            {{ $t('student_order.order_modal.code_title') + (entry ? entry.order_code : '') }}
          </div>
        </div>
        <!-- order date -->
        <div class="row">
          <div class="col-sm-12 text-center mb-2" style="font-size: 14px; color: rgb(127 155 204);">
            {{ $t('student_order.order_modal.label_order_date') + (entry ? entry.order_date : '') }}
          </div>
        </div>
        <!-- name and phone row -->
        <div class="row">
          <div class="col-sm-6 mb-3">
            {{ $t('student_order.order_modal.label_customer_name') + (entry ? entry.customer.customer_name : '') }}
          </div>
          <div class="col-sm-6 mb-3">
            {{ $t('student_order.order_modal.label_phone') + (entry ? entry.customer.phone_number : '') }}
          </div>
        </div>
        <!-- email -->
        <div class="row">
          <div class="col-sm-6 mb-3">
            {{ $t('student_order.order_modal.label_email') + (entry ? entry.customer.email : '') }}
          </div>
        </div>
        <!-- receiver and class row -->
        <div class="row">
          <div class="col-sm-6 mb-3">
            {{ $t('student_order.order_modal.label_receiver') + (entry ? entry.customer.student_name : '') }}
          </div>
          <div class="col-sm-6 mb-3">
            {{ $t('student_order.order_modal.label_class') + (entry ? entry.customer.student_class : '') }}
          </div>
        </div>
        <!-- payment method -->
        <div class="row">
          <div class="col-sm-7 mb-3">
            <div class="row align-items-center">
              <div class="app-align-middle" style="padding-left: 7.5px;">{{ $t('student_order.order_modal.label_payment_method') }}</div>
              <div class="flex-grow-1 ml-2">
                <app-select v-if="entry" @change=""
                                input-style="normal"
                                v-model="entry.payment"
                                :options-data="STUDENT_ORDER_LIST_CONSTANT.STUDENT_PAYMENT_METHOD" />
              </div>
            </div>
          </div>
        </div>
        <!-- paid status -->
        <div class="row">
          <div class="col-sm-7 mb-3">
            <div class="row align-items-center">
              <div class="app-align-middle" style="padding-left: 7.5px;">{{ $t('student_order.order_modal.label_paid_status') }}</div>
              <div class="flex-grow-1 ml-2">
                <app-select v-if="entry" @change=""
                                input-style="normal"
                                v-model="entry.paid_status"
                                :options-data="STUDENT_ORDER_LIST_CONSTANT.STUDENT_PAID_STATUS" />
              </div>
            </div>
          </div>
          <div class="col-sm-5 mb-3 text-right align-self-end">
            <button class="btn btn-success" style="height: 40px !important;"
              @click="handleAddItem"
            >
              {{ $t('student_order.order_modal.button_add_menu') }}
            </button>
          </div>
        </div>
        <!-- table items -->
        <div class="table-responsive">
          <table class="table app-table-list">
            <thead class="thead-light">
            <tr>
              <template v-for="(column, index) in columns">
                <th :key="index" :class="[column.fitSize ? 'cell-fit-content' : '']">
                  {{ column.label }}
                </th>
              </template>
            </tr>
            </thead>
            <tbody id="appTableList">
              <tr v-if="!order_items">
                <td colspan="100">
                  <span v-if="loading">
                    {{ $t("common.loading") }}
                  </span>
                  <span v-else>
                    {{ $t("common.list empty") }}
                  </span>
                </td>
              </tr>
              <tr v-else :key="item.id" :id="item.id" :data-id="entry.id" v-for="(item, itemIndex) in order_items">
                <!-- id -->
                <td class="app-align-middle text-center">
                  {{ itemIndex + 1 }}
                </td>
                <!-- serve_date -->
                <td class="app-align-middle text-left">
                  <p
                    :data-original-title="getFullDateString(item.sell_date)"
                    :class="['app-table-p app-cell-tooltip mb-0', checkLineBreak(getFullDateString(item.sell_date))]"
                  >
                    {{ getFullDateString(item.sell_date) }}
                  </p>
                </td>
                <!-- menu name -->
                <td class="app-align-middle text-left">
                  {{ item.name }}
                </td>
                <!-- size -->
                <td class="app-align-middle">
                  <p class=" app-table-p app-cell-tooltip mb-0">
                    <app-select @change="updateSizeMenu($event, itemIndex)"
                                input-style="normal"
                                v-model="item.size"
                                :options-data="STUDENT_ORDER_LIST_CONSTANT.ITEM_SIZE" />
                  </p>
                </td>
                <!-- price -->
                <td class="app-align-middle text-right">
                  {{ convertCurrency(item.price) }}
                </td>
                <!-- currency -->
                <td class="app-align-middle text-center">
                  {{  $t("common_vn.money_unit") }}
                </td>
                <!-- delete action -->
                <td class="app-align-middle text-center app-p-none">
                  <button
                    @click="handleBtnRemoveClick(itemIndex, item)"
                    class="btn btn-danger"
                  >
                    {{ $t("common_vn.delete") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- restaurant menus -->
      <transition name="slide">
        <div v-if="isOpenAddMenu" class="menu-view-container">
          <div class="menu-view">
            <div v-if="student_menus" class="row">
              <template v-for="(menu, menuIndex) in student_menus">
                <div v-if="isNotSelectedMenu(menu.id)" :key="menu.id" class="col-sm-6 col-lg-4">
                  <div class="card" style="overflow: hidden;">
                    <img :src="menu.image.url" class="card-img-top menu-image" alt="...">
                    <div class="card-body border-top border-light">
                      <div class="badge badge-info mb-2">{{ getFullDateString(menu.sell_date) }}</div>
                      <h6 class="card-title font-weight-bold menu-title mb-2" :title="menu.name">{{ menu.name }}</h6>
                      <div class="card-text menu-description" :title="menu.description">{{ menu.description }}</div>
                      <div class="row">
                        <div class="col-sm-4">
                          <app-radio
                            label="S"
                            :key="menu.id"
                            :val="STUDENT_ORDER_LIST_CONSTANT.ITEM_SIZE_VALUES.S"
                            v-model="menu.selected_size"
                          />
                        </div>
                        <div class="col-sm-4">
                          <app-radio
                            label="M"
                            :key="menu.id"
                            :val="STUDENT_ORDER_LIST_CONSTANT.ITEM_SIZE_VALUES.M"
                            v-model="menu.selected_size"
                          />
                        </div>
                        <div class="col-sm-4">
                          <app-radio
                            label="L"
                            :key="menu.id"
                            :val="STUDENT_ORDER_LIST_CONSTANT.ITEM_SIZE_VALUES.L"
                            v-model="menu.selected_size"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <div class="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          :checked="isTempSelected(menu.id)"
                          :id="'checkbox' + menu.id"
                          :key="'checkbox' + menu.id"
                          @click="handleSelectItem(menu.id)"
                        />
                        <label :for="'checkbox' + menu.id">{{ $t('student_order.order_modal.label_select_menu') }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-else>Loading...</div>
          </div>
          <div class="menu-footer d-flex align-items-center justify-content-between">
            <button class="btn btn-secondary" @click="isOpenAddMenu = false">{{ $t('common_vn.return') }}</button>
            <button class="btn btn-primary" @click="submitAddNewItem" :disabled="tempSelectedItems.length == 0">{{ $t('common_vn.confirm') }}</button>
          </div>
        </div>
      </transition>

      <!-- footer -->
       <div class="d-flex justify-content-end mt-4">
        <button
          @click="handleUpdateOrder"
          type="button"
          :class="['btn btn-primary']"
        >
          {{ $t("common_vn.update") }}
        </button>
        <!-- <button
          @click="__noticeWarning('Tính năng hiện đang phát triển')"
          type="button"
          :class="['btn btn-info']"
        >
          {{ $t("common_vn.export") }}
        </button> -->
       </div>
    </template>
    <template v-slot:footer>

    </template>
  </app-modal>

</template>

<script>
  import AppModal from "../../../components/_common/popup/AppModal";
  import AppBasicTable from "@components/_common/list/AppBasicTable";
  import {ENDPOINT} from "../../../constants/api";
  import {STUDENT_ORDER_LIST_CONSTANT} from "../../../constants/kyy_student_order_list";
  import {convertCurrency, getFullDateString} from "@utils";
  import AppCheckbox from '../../forms/AppCheckbox';

  export default {
    name: "KyyAppModalStudentOrder",
    components: {
      AppModal,
      "app-basic-table": AppBasicTable,
      "app-checkbox": AppCheckbox,
    },
    props : [
      "endPoint",
    ],
    methods: {
      hide(isUpdateSucces = false) {
        this.$refs.modal.hide();
        this.resetModal()
        if (isUpdateSucces) {
          this.$emit('handleUpdateSuccess');
        }
      },

      show(endPoint) {
        this.getDataEdit(endPoint)
        this.$refs.modal.show();
        // Refresh table data
        // this.$refs.basic_table.getEntries();
      },

      handlerClose() {
        this.resetModal()
        // this.$refs.modal.hide()
      },

      handlerSelectOrder(data) {
        this.$emit('selectOrder', data);
      },

      async getDataEdit(endPoint) {
        await this.$request.get(endPoint).then(res => {
          if (res.hasErrors()) {
            if (res.status === 'error'){
              this.__noticeError(this.$t(res.data.error_msg));
            }
          } else {
            this.entry = res.data.data
            this.order_items = res.data.data.student_order_items.map((orderItem) => {
              return {
                'kyy_menus_student_id': orderItem.kyy_menus_student_id,
                'sell_date': orderItem.menu_student.sell_date,
                'name': orderItem.menu_student.name,
                'size': orderItem.size,
                'price': this.getPriceBySize(orderItem.size, orderItem.menu_student),
                'price_s': orderItem.menu_student.price_s,
                'price_m': orderItem.menu_student.price_m,
                'price_l': orderItem.menu_student.price_l,
              }
            })
            this.original_order_items = res.data.data.student_order_items
          }
        })
        await this.$request.get(ENDPOINT.UI_HELPER_GET_VALID_STUDENT_ORDERS).then(res => {
          if (res.hasErrors()) {
            if (res.status === 'error'){
              this.__noticeError(this.$t(res.data.error_msg));
            }
          } else {
            this.student_menus = res.data.data.map((menu) => {
              menu.selected_size = STUDENT_ORDER_LIST_CONSTANT.ITEM_SIZE_VALUES.S
              return menu
            })
          }
        })
        this.$nextTick(() => {
          $.each($('.app-cell-tooltip'), (index, el) => {
            // Count number of paragraph
            let paras = $(el).text().split('\n');
            let count = 0;
            $.each(paras, (index, value) => {
              count++;
            });

            // Show tooltip
            if ((count >= 3) || (el.offsetWidth < el.scrollWidth)) {
              $(el).tooltip({boundary: 'window'})
            }
          })
        });
      },

      checkLineBreak(note) {
        try {
          if (note) {
            if (note.match(/\n/g)) {
              return 'text-break';
            }
          }
        } catch(err) {
          return ''
        }
      },

      // reset modal
      resetModal() {
        this.entry = null
        this.order_items = null
        this.original_order_items = null
        this.student_menus = null
        this.loading = true
        this.isOpenAddMenu = false
        this.tempSelectedItems = []
      },

      // update menu size order item
      updateSizeMenu(e, index) {
        this.order_items[index].size = e
        this.order_items[index].price = this.getPriceBySize(e, this.order_items[index])
      },

      // handle add items
      handleAddItem() {
        this.isOpenAddMenu = true
      },

      // handle delete item
      handleBtnRemoveClick(index, orderItem) {
        if (this.order_items.length == 1) {
          this.__noticeError('Required 1 menu')
          return
        }
        this.order_items = this.order_items.filter(item => item.kyy_menus_student_id !== orderItem.kyy_menus_student_id)
      },

      handleSelectItem(menuID) {
        if (this.tempSelectedItems.includes(menuID)) {
          this.tempSelectedItems = this.tempSelectedItems.filter(function(id) {
              return id !== menuID
          })
        } else {
          this.tempSelectedItems.push(menuID)
        }
      },

      isTempSelected(menuID) {
        return this.tempSelectedItems.includes(menuID)
      },

      isNotSelectedMenu(menuID) {
        for (const item of this.order_items) {
          if (item.kyy_menus_student_id == menuID) {
            return false
          }
        }
        return true
      },

      submitAddNewItem() {
        if (this.tempSelectedItems.length == 0) {
          return
        }
        let selectedItemArray = []
        for (const item of this.student_menus) {
          if (this.isTempSelected(item.id)) {
            let selectedItem = {}
            selectedItem.kyy_menus_student_id = item.id
            selectedItem.sell_date = item.sell_date
            selectedItem.name = item.name
            selectedItem.size = item.selected_size
            selectedItem.price = this.getPriceBySize(item.selected_size, item)
            selectedItem.price_s = item.price_s
            selectedItem.price_m = item.price_m
            selectedItem.price_l = item.price_l
            selectedItemArray.push(selectedItem)
          }
        }
        this.order_items = [...this.order_items, ...selectedItemArray]
        this.tempSelectedItems = []
        this.isOpenAddMenu = false
      },

      getPriceBySize(size, menuObject) {
        switch (Number(size)) {
          case STUDENT_ORDER_LIST_CONSTANT.ITEM_SIZE_VALUES.S:
            return menuObject.price_s
            break;
          case STUDENT_ORDER_LIST_CONSTANT.ITEM_SIZE_VALUES.M:
            return menuObject.price_m
            break;
          case STUDENT_ORDER_LIST_CONSTANT.ITEM_SIZE_VALUES.L:
            return menuObject.price_l
            break;
          default:
            return null
            break;
        }
      },

      // handle update order after every changes
      async handleUpdateOrder() {
        let params = {}
        params.paid_status = this.entry.paid_status
        params.payment = this.entry.payment
        params.order_items = this.order_items
        let res = null;
        let msg = "";
        res = await this.$request.patch(this.ENDPOINT.KYY_STUDENT_ORDER_EDIT(this.entry.id), params);
        msg = this.$t("common.msg update ok")
        if (res.hasErrors()) {
          this.__noticeError(res.data.error_msg != undefined ? res.data.error_msg : this.$t('common.error'));
        } else {
          this.__noticeSuccess(msg);
          this.hide(true)
        }
      }
    },
    data() {
      return {
        filters: {
          order_number: {
            name: "order_number",
            condition: "like",
            label: this.$t("order_list.order_number")
          },
          customer_name: {
            name: "customer_name",
            condition: "like",
            label: this.$t("order_list.customer_name")
          },
          customer_id: {
            name: "customer_id",
            condition: "equal",
            label: this.$t("receipts.customer_id")
          },
        },
        columns: [
          {name: "id", label: this.$t("common.id"), textAlign: 'text-center'},
          {name: "serve_date", label: this.$t("student_order.serve_date"), textAlign: 'text-center'},
          {name: "menu_name", label: this.$t("student_order.menu_name"), textAlign: 'text-center'},
          {name: "size", label: this.$t("student_order.size"), textAlign: 'text-center'},
          {name: "price", label: this.$t("student_order.price"), textAlign: 'text-center'},
          {name: "currency", label: this.$t("student_order.currency"), textAlign: 'text-center'},
          {name: "delete", label: this.$t("common_vn.action"), textAlign: 'text-center'},
        ],
        entry: null,
        order_items: null,
        original_order_items: null,
        student_menus: null,
        loading : true,

        // for menu selector
        isOpenAddMenu: false,
        tempSelectedItems: [],

      }
    },
    mounted() {
    },
  }
</script>
<style>
.menu-view-container {
  width: 100%;
  height: 100%;
  background-color: grey;
}

.menu-view {
  width: 100%; /* Full width */
  height: 100%; /* 70% height of the modal */
  background-color: #f0f0f0; /* Example background color */
  position: absolute; /* Position it absolutely within the modal */
  bottom: 0; /* Align it to the bottom of the modal */
  left: 0;
  right: 0;
  overflow-y: auto; /* If content overflows, add a scrollbar */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow */
}

.menu-view .row {
  padding: 10px 10px 0 10px;
  overflow: scroll;
  height: calc(100% - 60px);
}

.menu-footer {
  background-color: #fff;
  padding: 10px;
  border-top: 1px solid #ddd;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.menu-image {
  aspect-ratio: 4/3;
  width: 100%;
  height: auto;
  object-fit: cover;
}

.menu-title {
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
  width: 100%;
}

.menu-description {
  text-overflow: ellipsis;
  color: #666;
  font-size: 14px;
  height: 60px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* Slide-down transition */
.slide-enter-active, .slide-leave-active {
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.slide-enter, .slide-leave-to /* .slide-leave-active in <2.1.8 */ {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

/* Set height to 90% */
.slidable-content {
  height:100%;
  max-height: 90vh; /* Ensure it respects the viewport height */
  opacity: 1;
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

</style>
